import {ReactNode} from 'react';

import Head from 'next/head';
import {useAssetUrl} from 'mkt-ssr/lib/assets/useAssetUrl';

// eslint-disable-next-line no-restricted-imports
import sohneFont from '../../../public/fonts/Sohne.woff2';
// eslint-disable-next-line no-restricted-imports
import sourceCodeProFont from '../../../public/fonts/SourceCodePro-Medium.woff2';

interface FontProviderProps {
  children: ReactNode;
}

/**
 * Support preloading of fonts for SSR to optimize initial page load and avoid
 * layout shifts.
 *
 * Note that using next/font/local instead of this approach ~mostly works but messes
 * with our variable width font because it's trying to be too clever.
 */
export function FontProvider({children}: FontProviderProps) {
  const sohneFontUrl = useAssetUrl(sohneFont);
  const sourceCodeProFontUrl = useAssetUrl(sourceCodeProFont);
  return (
    <>
      <Head>
        <link
          rel="preload"
          href={sohneFontUrl}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href={sourceCodeProFontUrl}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
      </Head>
      {children}
    </>
  );
}
